import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile-betslip-panel"
}
const _hoisted_2 = { class: "mobile-betslip-header" }
const _hoisted_3 = { class: "mobile-betslip-title" }
const _hoisted_4 = { class: "desktop-modal-box" }
const _hoisted_5 = { class: "desktop-modal-header" }
const _hoisted_6 = { class: "desktop-modal-title" }
const _hoisted_7 = { class: "desktop-modal-content" }

import BetSlip from '@/components/BetSlip.vue'
import { iframeCommunication } from '@/utils/iframeCommunication';
import { ref, onMounted, onUnmounted, watch, nextTick } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BetslipModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isMobile = ref(false)
const mobileBetslipScrollEl = ref<HTMLElement | null>(null)

const checkMobile = () => {
  isMobile.value = window.matchMedia('(max-width: 768px)').matches
}

const isInIframe = iframeCommunication.isRunningInIframe()

function scrollMobilePanelToTop() {
  const wrap = mobileBetslipScrollEl.value
  if (!wrap) return
  wrap.scrollTop = 0
  const slip = wrap.querySelector('.betslip') as HTMLElement | null
  if (slip) slip.scrollTop = 0
}

/** Preserve page scroll when locking body for full-screen mobile panel (standalone only). */
let bodyScrollLockY = 0

const lockBodyScroll = () => {
  if (isInIframe) return
  bodyScrollLockY = window.scrollY || document.documentElement.scrollTop
  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.width = '100%'
  document.body.style.top = `-${bodyScrollLockY}px`
}

const unlockBodyScroll = () => {
  if (isInIframe) return
  document.body.style.overflow = ''
  document.body.style.position = ''
  document.body.style.width = ''
  document.body.style.top = ''
  window.scrollTo(0, bodyScrollLockY)
}

// Watch for mobile panel open/close
watch(() => props.isOpen, (isOpen) => {
  if (isOpen && isMobile.value && isInIframe) {
    iframeCommunication.sendScrollToTop()
    window.scrollTo(0, 0)
  }

  if (isMobile.value && isOpen) {
    lockBodyScroll()
    nextTick(() => {
      scrollMobilePanelToTop()
      requestAnimationFrame(() => {
        scrollMobilePanelToTop()
        requestAnimationFrame(scrollMobilePanelToTop)
      })
    })
  } else if (isMobile.value && !isOpen) {
    unlockBodyScroll()
  }
})

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
  unlockBodyScroll()
})

const close = () => emit('close')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isMobile.value && _ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('betslip.title')), 1),
            _createElementVNode("button", {
              class: "mobile-close-button",
              onClick: close
            }, "×")
          ]),
          _createElementVNode("div", {
            ref_key: "mobileBetslipScrollEl",
            ref: mobileBetslipScrollEl,
            class: "mobile-betslip-content"
          }, [
            _createVNode(BetSlip, { onClose: close })
          ], 512)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "modal-slide-down" }, {
      default: _withCtx(() => [
        (!isMobile.value && _ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "desktop-modal-overlay",
              onClick: _withModifiers(close, ["self"])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('betslip.title')), 1),
                  _createElementVNode("button", {
                    class: "desktop-close-button",
                    onClick: close
                  }, "×")
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(BetSlip, { onClose: close })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})